<template>
    <div class="attivita-container">
        <!-- Header dell'attività -->
        <div class="d-flex align-items-center p-2 bg-light rounded cursor-pointer"
             @click="toggleExpanded()"
             :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }">
            <i v-if="hasSubItems"
               :class="expanded ? 'ph-caret-down' : 'ph-caret-right'"
               class="me-2"></i>
            <i v-else class="me-2" style="width: 1em;"></i>

            <strong style="flex: 1;">{{ attivita.TITOLO }}</strong>

            <div class="d-flex gap-2">
                <span v-if="hasVoci" class="badge bg-secondary">{{ attivita.VOCI.length }} {{ utils.plurale(attivita.VOCI.length, 'voce', 'voci') }}</span>
                <span v-if="hasSottoAttivita" class="badge bg-info">{{ attivita.SOTTO_ATTIVITA.length }} {{ utils.plurale(attivita.SOTTO_ATTIVITA.length, 'sottoattività', 'sottoattività') }}</span>
            </div>
        </div>

        <!-- Contenuto espanso -->
        <div v-if="expanded" :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }" class="expanded-content">
            <!-- Sottoattività -->
            <div v-if="hasSottoAttivita" class="sotto-attivita-container">
                <TabAttvitaSchedaVisualizzazioneProgetto
                    v-for="sotto in attivita.SOTTO_ATTIVITA"
                    :key="sotto.ID_ATTIVITA"
                    :attivita="sotto"
                    :filters="filters"
                    :level="level + 1"
                    :tipo="tipo"
                    :force-expanded="forceExpanded"
                />
            </div>

            <!-- Voci -->
            <div v-if="hasVoci" class="mt-2 table-responsive">
                <table class="table table-sm table-hover mb-0">
                    <thead class="table-light">
                        <tr>
                            <th :style="{ width: tipo == 'acquisto' ? '40%' : '46%' }">Titolo Voce</th>
                            <th v-for="col in colonne" :key="col.campo" :style="{ width: col.width }">{{ col.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="voce in attivita.VOCI" :key="voce.ID_VOCE">
                            <td class="fs-sm">
                                <i class="ph-file-text me-1 text-muted"></i>
                                {{ voce.TITOLO_VOCE }}
                            </td>
                            <td v-for="col in colonne" :key="col.campo" class="fs-sm" :class="{ 'fw-bold': col.bold }">
                                <template v-if="col.euro">&euro; {{ filters.formattaImporto(voce[col.campo]) }}</template>
                                <template v-else>{{ voce[col.campo] || '-' }}</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Messaggio se non c'è nulla -->
            <div v-if="!hasVoci && !hasSottoAttivita" class="text-muted p-2 mt-2">
                Nessun contenuto disponibile
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabAttivitaSchedaVisualizzazioneProgetto",
    props: {
        attivita: {
            type: Object,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        tipo: {
            type: String,
            default: 'vendita'
        },
        forceExpanded: {
            type: Boolean,
            default: null
        }
    },
    watch: {
        forceExpanded: {
            immediate: true,
            handler(val) {
                if (val != null) this.expanded = val;
            }
        }
    },
    data() {
        return {
            expanded: false,
            utils: global.utils
        }
    },
    computed: {
        hasVoci() {
            return this.attivita.VOCI && this.attivita.VOCI.length > 0;
        },
        hasSottoAttivita() {
            return this.attivita.SOTTO_ATTIVITA && this.attivita.SOTTO_ATTIVITA.length > 0;
        },
        hasSubItems() {
            return this.hasVoci || this.hasSottoAttivita;
        },
        colonne() {
            if (this.tipo == 'acquisto') return [
                { label: 'Qta', campo: 'QUANTITY_COST_ESPOSTO', width: '8%' },
                { label: 'Rip.', campo: 'DAYS_COST_ESPOSTO', width: '8%' },
                { label: 'Costo Unit.', campo: 'UNIT_COST_ESPOSTO', width: '14%', euro: true },
                { label: 'Costi', campo: 'TOTAL_COST_ESPOSTO', width: '15%', euro: true, bold: true },
                { label: 'Commissioni', campo: 'TOTAL_COST_PRIVATO', width: '15%', euro: true },
            ];
            return [
                { label: 'Qta', campo: 'QUANTITY_PRICE', width: '10%' },
                { label: 'Rip.', campo: 'DAYS_PRICE', width: '10%' },
                { label: 'Prezzo Unit.', campo: 'UNIT_PRICE', width: '17%', euro: true },
                { label: 'Totale', campo: 'TOTAL_PRICE', width: '17%', euro: true, bold: true },
            ];
        }
    },
    methods: {
        toggleExpanded() {
            if (this.hasSubItems) this.expanded = !this.expanded;
        }
    }
}
</script>

<style scoped>
.attivita-container {
    margin-bottom: 0.5rem;
}

.expanded-content {
    margin-top: 0.5rem;
}

.sotto-attivita-container {
    margin-bottom: 0.75rem;
}

.cursor-pointer {
    cursor: pointer;
    transition: background-color 0.2s;
}

.cursor-pointer:hover {
    background-color: #e8e8e8 !important;
}
</style>
